export const ADD_TO_CART_BUTTON_TEXT_DEFAULT = `В корзину`;
export const ADD_TO_CART_BUTTON_TEXT_ADDED = `В корзине`;
